import React from 'react';
import {Pagination, SelectField} from '@albert-io/atomic';
import {pushQueryParams} from 'client/history';

interface Props {
  limit: string;
  page: string;
  total?: number;
  rowSizeOptions: {value: number}[];
}

export const ReportsPagination = ({limit, page, total, rowSizeOptions}: Props) => {
  if (!total) {
    return null;
  }
  const totalPages = Math.ceil(total / Number(limit));

  return (
    <div className='u-display_flex u-align-items_center u-justify-content_flex-end u-mar-t_2'>
      <SelectField
        className='reports-table__show-rows'
        options={rowSizeOptions}
        defaultValue={`${limit}`}
        label='Show rows:'
        size='s'
        inline
        onChange={(e) => {
          const rowSize = parseInt(e.target.value, 10);
          pushQueryParams({limit: rowSize});
        }}
      />
      <Pagination
        className='u-mar-l_2'
        totalPages={totalPages}
        defaultPage={Number(page)}
        variation={typeof total === 'undefined' ? 'micro' : 'condensed'}
        onChange={(newPage) => {
          pushQueryParams({page: newPage});
        }}
      />
    </div>
  );
};
